// extracted by mini-css-extract-plugin
export var featuresGrid = "featuresGridIcon-module--featuresGrid--VpQ3j";
export var featuresItem = "featuresGridIcon-module--featuresItem--U4lpS";
export var icon = "featuresGridIcon-module--icon--Id+tw";
export var text = "featuresGridIcon-module--text--Gq9Gk";